import styled from 'styled-components';

const DivThreadAction = styled.div`
  position: fixed;
  display: flex;
  gap: 16px;
  bottom: 32px;
  right: 32px;
`;

export default DivThreadAction;
